import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { AutoPlanModel } from '../models/auto-plan.model';
import { isNullOrUndefined } from 'util';

@Component({
    selector: 'sc-auto-plan-operations',
    templateUrl: './auto-plan-operations.component.html',
    styleUrls: ['./auto-plan-operations.component.scss']
})

export class AutoPlanOperationsComponent implements OnInit {

    @Input() operations: any;
    @ViewChild('modalDescargas', { static: true }) modalDescargas;
    policyData = {
        policyNumber: ''
    };

    constructor() { }

    ngOnInit(){}

    openModal(operation) {
        this.policyData.policyNumber = operation.policyNumberComplete;
        this.modalDescargas.open();
    }

    getName(item: AutoPlanModel) {
        if (isNullOrUndefined(item.firstName)) {
            return item.companyname;
        } else {
            return `${item.firstName} ${item.lastName}`;
        }
    }
}
